import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { Card } from '../components/ui/card';
import { HelpCircle } from 'lucide-react';

const FAQPage = () => {
  const faqs = [
    {
      question: "What areas do you serve?",
      answer: "We proudly serve Lexington, KY and all surrounding cities within a 100-mile radius. For locations beyond 100 miles, additional travel fees may apply. Contact us to confirm service availability in your area."
    },
    {
      question: "Are your cleaners background-checked and insured?",
      answer: "Yes! All our team members undergo thorough background checks and are fully insured. We've been a licensed and insured cleaning service since 1983, providing peace of mind to all our clients."
    },
    {
      question: "Do you bring your own cleaning supplies and equipment?",
      answer: "Yes, we provide all necessary cleaning supplies and professional-grade equipment. We use eco-friendly products that are safe for your family, pets, and the environment. If you have specific product preferences, we're happy to accommodate."
    },
    {
      question: "How do I get a quote for cleaning services?",
      answer: "Getting a quote is easy! You can fill out our online quote request form, book a consultation through our website, or email us at tpcslex@gmail.com. We'll respond within 24 hours with a customized estimate based on your specific needs."
    },
    {
      question: "Can I schedule recurring cleaning services?",
      answer: "Absolutely! We offer flexible scheduling options including daily, weekly, bi-weekly, and monthly recurring services. Recurring clients often receive priority scheduling and special rates."
    },
    {
      question: "What if I'm not satisfied with the cleaning?",
      answer: "Your satisfaction is our top priority. We offer a 100% satisfaction guarantee. If you're not completely happy with our service, let us know within 24 hours and we'll return to address any concerns at no additional charge."
    },
    {
      question: "Do you offer same-day or emergency cleaning services?",
      answer: "Yes! We understand that emergencies happen. Contact us as early as possible, and we'll do our best to accommodate same-day requests based on availability."
    },
    {
      question: "What's included in a deep cleaning service?",
      answer: "Our deep cleaning service includes everything in a standard cleaning plus detailed attention to areas often missed: baseboards, ceiling fans, inside cabinets, appliances (inside ovens and refrigerators), window sills, light fixtures, and more. It's perfect for seasonal refreshes or preparing for special events."
    },
    {
      question: "How long does a typical cleaning take?",
      answer: "Cleaning time varies based on the size of your property and the type of service. A standard residential cleaning typically takes 2-4 hours, while deep cleaning may take 4-8 hours. We'll provide an estimated timeframe when we give you your quote."
    },
    {
      question: "Do I need to be home during the cleaning?",
      answer: "No, you don't need to be present. Many of our clients provide us with a key or access code. We're trusted professionals with over 40 years of experience. However, you're always welcome to be home if you prefer."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept various payment methods including cash, check, and all major credit cards. Payment is typically due upon completion of service unless other arrangements have been made."
    },
    {
      question: "Do you clean commercial properties after hours?",
      answer: "Yes! We understand that businesses need cleaning services that don't disrupt operations. We offer flexible scheduling including evening and weekend service for commercial clients."
    },
    {
      question: "How far in advance should I book?",
      answer: "We recommend booking at least 3-5 days in advance to ensure availability, especially during busy seasons. However, we'll always try to accommodate last-minute requests whenever possible."
    },
    {
      question: "What should I do to prepare for your cleaning team?",
      answer: "We ask that you pick up any personal items, toys, or clutter from surfaces so our team can focus on cleaning. Secure any valuables and let us know about any areas that need special attention or should be avoided."
    },
    {
      question: "Do you offer specialized cleaning services?",
      answer: "Yes! In addition to residential and commercial cleaning, we offer specialized services including post-construction cleaning, gym sanitization, restaurant kitchen cleaning, warehouse cleaning, retail store cleaning, and Air BnB turnovers. Contact us for details on any specialized service you need."
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-black text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <HelpCircle className="w-16 h-16 text-red-600 mx-auto mb-4" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Frequently Asked <span className="text-red-600">Questions</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Find answers to common questions about our cleaning services
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="p-6">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className="text-left font-semibold">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-700">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Card>

          {/* Still have questions CTA */}
          <div className="mt-12 text-center bg-white p-8 rounded-lg shadow-md">
            <h3 className="text-2xl font-bold mb-4">Still Have Questions?</h3>
            <p className="text-gray-600 mb-6">
              Can't find the answer you're looking for? We're here to help!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="/contact" 
                className="inline-flex items-center justify-center px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md transition-colors"
              >
                Contact Us
              </a>
              <a 
                href="mailto:tpcslex@gmail.com" 
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-300 hover:border-red-600 hover:text-red-600 font-medium rounded-md transition-colors"
              >
                Email Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQPage;
